import { render, staticRenderFns } from "./Item.vue?vue&type=template&id=321df034&scoped=true"
import script from "./Item.vue?vue&type=script&lang=js"
export * from "./Item.vue?vue&type=script&lang=js"
import style0 from "./Item.vue?vue&type=style&index=0&id=321df034&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321df034",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('321df034')) {
      api.createRecord('321df034', component.options)
    } else {
      api.reload('321df034', component.options)
    }
    module.hot.accept("./Item.vue?vue&type=template&id=321df034&scoped=true", function () {
      api.rerender('321df034', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/components/Sidebar/Item.vue"
export default component.exports